(function ($) {

'use strict';

	/**
	 * accordion handler
	 * Implements a accordion effect.
	 * 
	 * A class is required to hide the container elements. CSS 'display:none' is 
	 * removed by the handler after .hide() is called for containers. Otherwise 
	 * the CSS media queries could not be used when print a page to ensure
	 * all containers are visible.
	 * @param {object} config - configuration options
	 * @returns {undefined}
	 */
	$.fn.mpAccordion = function (config) {

		/**
		 * Resize handler
		 */
		function accordionResizeHandler() {
			clearTimeout(resizeTimoutID);

			resizeTimoutID = setTimeout(function () {
				var newWidth = $(window).width();
				if (windowWidth !== newWidth) {
					windowWidth = newWidth;
					initAccordion(options);
				}
			}, 300);
		}

		/**
		 * Prevent multiple handled click events and the requirement 
		 * to use 'return false;" to exit the mpSection click handlers
		 * So it's prossible for other modules to install and use their own 
		 * .on('click') handlers.
		 * 		 
		 * Returns true if the period since the last handled click event exceeds 
		 * 50 milliseconds.
		 * @returns {Boolean} true if the event should be handled
		 */
		function handleSingleClick() {
			var now = Date.now();
			if ((now - lastClickEventTime) > 50) {
				lastClickEventTime = now;
				return true;
			}
			return false;
		}

		/**
		 * Initialize the accordion sections
		 */
		function initAccordion() {
			if (initActive) {
				resizeTimoutID = setTimeout(function () {
					initAccordion(options);
				}, 300);
			}

			initActive = true;

			var mpContainersActive = 0;
			var $firstTitle = null;
			var hiddenHeight = 0;
			var removeClasses = options.containerHideClass + ' ' + options.containerNoHideClass;
			var elemCnt = 0;

			// unregister click handlers
			$myThis.off('click dblclick');
			// remove dynamic added classes
			$(options.containerSelector).removeClass(removeClasses);
			$titleElems.removeClass(removeClasses);
			// remove state span's
			$('.' + options.titleSectionPrefixClass).remove();

			// init sections
			$titleElems.each(function (index) {
				var $containerElem = $(this).next(options.containerSelector);
				var containerHeight = $containerElem.height();

				// set id to the sections to enable anchor jumping
				$(this).attr('id', options.anchorIdPrefix + (++elemCnt));
				if (hiddenHeight === 0) {
					// hide container to get the hidden height
					$containerElem.addClass(options.containerHideClass);
					hiddenHeight = $containerElem.height();
					$containerElem.removeClass(options.containerHideClass);
				}

				var sectionCreated = false;
				// check if container did'nt need more height when in visible state
				if (!$containerElem.find(options.ignoreHeightCheckselector).length === 0 &&
						(options.disableAccordion ||
								$(this).parents(options.ignoreIfParentsClass).length > 0 || // if this is a search result page, all containers are open and click handler is disabled
								containerHeight <= parseInt($containerElem.css('line-height'), 10) ||
								containerHeight <= hiddenHeight ||
								($firstTitle === null && index === (titleCount - 1)))) {

					$containerElem.addClass(options.containerNoHideClass);
					$(this).addClass(options.containerNoHideClass);
					sectionCreated = true;
				} else if ($firstTitle === null ||
						options.initOpenSections) {

					if ($firstTitle === null) {
						$firstTitle = $(this);
					}
					// create section
					if (!options.initClosedSections) {
						createTitleLink($(this));
						// state open section
						$(this).prepend('<a href="javascript:;" class="' + options.titleSectionPrefixClass + '" aria-hidden="true"><span>' + options.openedSectionPrefixString + '</span></a>');
						// set the title for visible sections
						$(this).attr('title', $.i81n.text('CLICKTOHIDEAREA'));
						$(this).find('a.' + options.titleSectionPrefixClass + ', .mpi-titlelink').attr('title', $.i81n.text('CLICKTOHIDEAREA'));
						var $titleLink = $(this).find('.mpi-titlelink');
						$titleLink.attr('aria-label', $titleLink.text() + ' ' + $.i81n.text('CLICKTOHIDEAREA') + ' ');
						$(this).addClass(options.openedTitleClass);
						createOpenHideAll($(this), ($firstTitle === null));
						++mpContainersActive;

						sectionCreated = true;
					}
				}
				// state closed section
				if (!sectionCreated) {
					// do not hide the container if only one container exists
					if ($titleElems.length > 1) {
						$containerElem.addClass(options.containerHideClass);
						createTitleLink($(this));
						// state closed section
						$(this).prepend('<a href="javascript:;" class="' + options.titleSectionPrefixClass + '" aria-hidden="true"><span>' + options.closedSectionPrefixString + '</span></a>');
						// set the title for invisible sections
						$(this).attr('title', $.i81n.text('CLICKTOSHOWAREA'));
						$(this).find('a.' + options.titleSectionPrefixClass + ', .mpi-titlelink').attr('title', $.i81n.text('CLICKTOSHOWAREA'));
						var $titleLink = $(this).find('.mpi-titlelink');
						$titleLink.attr('aria-label', $titleLink.text() + ' ' + $.i81n.text('CLICKTOSHOWAREA') + ' ');
						$(this).addClass(options.closedTitleClass);
						createOpenHideAll($(this));
					}
					++mpContainersActive;
				}
			});
			
			// if only one section requires more height, no click handlers are needed 
			// Remove the titlePrefix and add the options.containerNoHideClass
			if (mpContainersActive < 2 && $firstTitle !== null) {
				$firstTitle.find('.' + options.titleSectionPrefixClass).empty();
				$firstTitle.addClass(options.containerNoHideClass);
				$firstTitle.next(options.containerSelector).addClass(options.containerNoHideClass);
				$myThis.find('.mp-openall, .mp-closeall').remove();
			}

			if (!options.disableAccordion) {

				/////////////////////////////////////////////////
				// Register click/dblclick handlers
				/////////////////////////////////////////////////	

				/**
				 * Register click handler for the section titles and show/hide all elements
				 */
				$myThis.find(options.containerSelector).not('.' + options.containerNoHideClass).parent().find(options.titleSelector).off('click').on('click', function () {
					if (handleSingleClick()) {
						$clickObject = $(this).parent();
						clickHandler($clickObject);
					}
				}); // click()	
				$myThis.find(options.containerSelector).not('.' + options.containerNoHideClass).parent().find('.mp-openall').off('click').on('click', function () {
					if (handleSingleClick()) {
						$clickObject = $(this).parent();
						openState($myThis.find(options.containerSelector).parent(), 300);
					}
				}); // click()	
				$myThis.find(options.containerSelector).not('.' + options.containerNoHideClass).parent().find('.mp-closeall').off('click').on('click', function () {
					if (handleSingleClick()) {
						$clickObject = $(this).parent();
						closeState($myThis.find(options.containerSelector).parent(), 300);
					}
				}); // click()	

				// if an anchor is present trigger a click to this section
				if(location.href.indexOf('#') > -1){
					var anchor = location.href.substring(location.href.indexOf('#') + 1);
					if (anchor && anchor.substr(0, options.anchorIdPrefix.length) === options.anchorIdPrefix) {
						if (!options.initOpenSections) {
							hideVisible(0);
						}
						openState($('#' + anchor).parent());
					}else if($('#' + anchor).closest('.mp-section').find('[id^="' + options.anchorIdPrefix + '"]').length){
						// if the anchor is inside of an accordion, trigger a click to the parent
						if (!options.initOpenSections) {
							hideVisible(0);
						}
						openState($('#' + anchor).closest('.mp-section'));
					}
				}
			}

			initActive = false;
		} // initAccordion()

		/**
		 * create <a> element for titles
		 * @param {jQuery} $titleElem
		 * @returns {undefined}
		 */
		function createTitleLink($titleElem) {
			if ($titleElem.find('a').length < 1) {
				$titleElem.html('<a class="mpi-titlelink" href="javascript:;" accesskey="h">' + $titleElem.html() + '</a>');
				$titleElem.find('a').on('click', function () {
					$titleElem.trigger('click');
				});
			}
		}

		/**
		 * create the open/hide all span elements
		 * @param {jQuery} $elem
		 * @param {bool} createOpenCloseElems
		 * @returns {undefined}
		 */
		function createOpenHideAll($elem, createOpenCloseElems) {
			if ($elem.find('.' + options.showHideAllClass).length < 1) {
				$elem.append('<a href="javascript:;" class="mp-closeall ' + options.showHideAllClass + '" title="' + $.i81n.text('CLICKTOHIDEALLAREA') + '" aria-hidden="true"><span>' + options.closeAllSectionString + '</span></a>')
						.append('<a href="javascript:;" class="mp-openall ' + options.showHideAllClass + '" title="' + $.i81n.text('CLICKTOSHOWALLAREA') + '" aria-hidden="true"><span>' + options.openAllSectionString + '</span></a>');
				// set accesskey for the first section heading only
				if (createOpenCloseElems) {
					$elem.first().find('.mp-openall').attr('accesskey', 'a');
					$elem.first().find('.mp-closeall').attr('accesskey', 'n');
				}
			}
		}

		/////////////////////////////////////////////////
		// functions for click handling
		/////////////////////////////////////////////////

		/**
		 * hide all visible elements 
		 * @param {int} duration
		 */
		function hideVisible(duration) {
			// hide all visible sections
			$myThis.find(options.containerSelector).not('.' + options.containerHideClass + ', .' + options.containerNoHideClass).each(function () {
				// state closed section
				$(this).prev().find('.' + options.titleSectionPrefixClass + '>span').first().html(options.closedSectionPrefixString);
				$(this).attr('title', $.i81n.text('CLICKTOSHOWAREA'));
				$(this).find('.mpi-titlelink').attr('title', $.i81n.text('CLICKTOSHOWAREA'));
				$(this).find('.mpi-titlelink').attr('aria-label', $.i81n.text('CLICKTOSHOWAREA') + ' ');
				$(this).find('a.' + options.titleSectionPrefixClass).attr('title', $.i81n.text('CLICKTOSHOWAREA'));
				$(this).prev().removeClass(options.openedTitleClass).addClass(options.closedTitleClass);

				// hide container
				$(this).hide((typeof (duration) === 'undefined' ? options.animateDuration : duration), function () {
					$(this).addClass(options.containerHideClass);
					$(this).css('display', '');
				});
			});
		}

		/**
		 * open passed element
		 * @param {jQuery object} $elem
		 * @param {int} duration
		 * @returns {undefined}
		 */
		function openState($elem, duration) {

			$elem.each(function () {
				var $thisElem = $(this);
				// state open section
				var $openCloseElem = $thisElem.find('.' + options.titleSectionPrefixClass + '>span').first();
				if ($openCloseElem.length < 1) {
					return;
				}

				$openCloseElem.html(options.openedSectionPrefixString);
				$thisElem.find(options.titleSelector).attr('title', $.i81n.text('CLICKTOHIDEAREA'));
				$thisElem.find('.mpi-titlelink').attr('title', $.i81n.text('CLICKTOHIDEAREA'));
				$thisElem.find('.mpi-titlelink').attr('aria-label', $.i81n.text('CLICKTOHIDEAREA') + ' ');
				$thisElem.find(options.titleSelector + ' a.' + options.titleSectionPrefixClass).attr('title', $.i81n.text('CLICKTOHIDEAREA'));
				$thisElem.find(options.titleSelector).removeClass(options.closedTitleClass).addClass(options.openedTitleClass);

				// show container for this clicked section and scroll to top
				var $containerElem = $thisElem.children(options.containerSelector);
				$containerElem.show((typeof (duration) === 'undefined' ? options.animateDuration : duration), function () {
					$containerElem.removeClass(options.containerHideClass);

					if (options.scrollOpenedToView) {
						// scroll element into view
						if (!$thisElem.isElementInViewport()) {
							$thisElem[0].scrollIntoView(true);
						}
						// scroll section element into view
						var $pageHead = $('#pagehead');
						if ($pageHead.length > 0) {
							$(window).scrollTop($(window).scrollTop() - ($pageHead.position().top + $pageHead.height()));
						}
					}
					// update browser history to ensure the last opened section is active
					var url = location.href;
					var pos = url.indexOf('#');
					if (pos > -1) {
						url = url.substr(0, pos);
					}
					url += '#' + $thisElem.find(options.titleSelector).attr('id');
					history.replaceState({}, '', url);
					$containerElem.show();
					if(typeof options.callbackShow === 'function'){
						options.callbackShow($containerElem);
					}
				});
			});
		}

		/**
		 * close passed element
		 * @param {jQuery object} $elem
		 * @param {int} duration
		 * @returns {undefined}
		 */
		function closeState($elem, duration) {
			$elem.each(function () {
				var $thisElem = $(this);
				// state open section
				var $openCloseElem = $thisElem.find('.' + options.titleSectionPrefixClass + '>span').first();
				if ($openCloseElem.length < 1) {
					return;
				}
				// state closed section
				$openCloseElem.html(options.closedSectionPrefixString);
				$thisElem.find(options.titleSelector).attr('title', $.i81n.text('CLICKTOSHOWAREA'));
				$thisElem.find('.mpi-titlelink').attr('title', $.i81n.text('CLICKTOSHOWAREA'));
				$thisElem.find('.mpi-titlelink').attr('aria-label', $.i81n.text('CLICKTOSHOWAREA') + ' ');
				$thisElem.find(options.titleSelector + ' a.' + options.titleSectionPrefixClass).attr('title', $.i81n.text('CLICKTOSHOWAREA'));
				$thisElem.find(options.titleSelector).removeClass(options.openedTitleClass).addClass(options.closedTitleClass);

				var $containerElem = $thisElem.children(options.containerSelector);
				$containerElem.hide((typeof (duration) === 'undefined' ? options.animateDuration : duration), function () {
					$containerElem.addClass(options.containerHideClass);
					//$containerElem.css('display', '');
					$containerElem.show();
					if(typeof options.callbackHide === 'function'){
						options.callbackHide($containerElem);
					}
					
				});
			});
		}

		/**
		 * show the passed section, hide all others
		 * @param {type} $elem
		 * @param {type} duration
		 * @returns {undefined}
		 */
		function showSection($elem, duration) {
			// check if element is NOT visible
			if ($elem.children(options.containerSelector).hasClass(options.containerHideClass)) {
				// hide all visible sections
				hideVisible(0);
				// change to opened section
				openState($elem, duration);
			} else if ($(options.titleSelector).length === 1) {
				// change to closed section
				closeState($elem, duration);
			}
		}

		/**
		 * click handler action
		 * @param {jQuery object} $elem
		 * @returns {undefined}
		 */
		function clickHandler($elem) {
			// check if element is NOT visible
			if ($elem.find(options.containerSelector).hasClass(options.containerHideClass)) {
				if (options.switchStates) {
					showSection($elem);
				} else {
					openState($elem);
				}
			} else {
				closeState($elem);
			}
		}

		///////////////////
		// main code
		
		if ($(this).length < 1) {
			return null;
		}

		/**
		 * configuration options for mpAccordion instance
		 * @type @exp;jQuery@call;extend
		 */
		var options = jQuery.extend({
			name: 'mpAccordion',
			titleSelector: '.mp-section-title', // to find the title elements
			containerSelector: '.container', // to find the container elements
			containerHideClass: 'mp-section-container-hide', // class to hide the container, this is required for all containers to be visible when output to printer
			containerNoHideClass: 'mp-section-container-nohide', // class to prevent hiding the container
			titleSectionPrefixClass: 'mp-section-titleprefix', // class used by <span> of the title opened-/closed prefix string
			showHideAllClass: 'mp-showhide-all', // class used by <span> of the show/hide all string
			openedTitleClass: 'opened', // class added to title elements of opened sections
			closedTitleClass: 'closed', // class added to title elements of closed sections
			closedSectionPrefixString: '\u25BA', // prefix string to state closed containers
			openedSectionPrefixString: '\u25BC', // prefix string to state open containers
			closeAllSectionString: '\u2501', // used for opening all sections 
			openAllSectionString: '\u2550', // used for opening all sections 
			ignoreIfParentsClass: '.searchcontent', // ignore the section if a perent with the specified class is found
			anchorIdPrefix: 'sect', // prefix string when build the anchor id's
			animateDuration: 150, // duration when animation are used
			switchStates: true, // if false single sections opens and closes on click and don't handle other sections
			initOpenSections: false, // initialize all section in open state
			initClosedSections: false, // initialize all section in closed state
			disableAccordion: false, // initialize all secitons opened and unclickable
			showOpenHideAll: true, // create span elements to open/hide all sections
			scrollOpenedToView: false, // scroll the opened section 
			ignoreHeightCheckselector: '.chart',	// If a child of the options.containerSelector element matches the selector, the height check would be skipped
			callbackShow: null,
			callbackHide: null
		}, (config || {}));

		// Values required to handle click/dblClick 
		var $clickObject = null;
		var windowWidth = $(window).width();
		var $myThis = $(this);


		// initialize the elements

		var $titleElems = $myThis.children(options.titleSelector);
		var titleCount = $titleElems.length;
		var resizeTimoutID = 0;
		var initActive = false;
		var lastClickEventTime = 0;

		initAccordion();

		$(window).on('resize', accordionResizeHandler);

		// return a closure that the options could be modified at runtime
		return {
			changeOptions: function (opt) {
				options = jQuery.extend(options, (opt || {}));
			}
		};

	}; // $.fn.mpAccordion 

}(jQuery));